import { useEffect, useRef, useState } from 'react';

const BASE = 2000;
const CAP = 2150;
const MIN_INTERVAL_MS = 8000;
const MAX_INTERVAL_MS = 15000;

/**
 * Live-feeling counter. Starts at BASE, increments by 1 every 8-15s up to CAP.
 * Persists last value in localStorage so values don't reset on every reload.
 */
export default function useLiveCounter() {
  const STORAGE_KEY = 'bpm_live_counter';
  const [count, setCount] = useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) {
        const v = parseInt(raw, 10);
        if (Number.isFinite(v) && v >= BASE && v <= CAP) return v;
      }
    } catch (e) { /* ignore */ }
    return BASE;
  });
  const timerRef = useRef(null);

  useEffect(() => {
    const tick = () => {
      setCount((prev) => {
        if (prev >= CAP) return prev;
        const next = prev + 1;
        try { localStorage.setItem(STORAGE_KEY, String(next)); } catch (e) { /* ignore */ }
        return next;
      });
      const delay = MIN_INTERVAL_MS + Math.random() * (MAX_INTERVAL_MS - MIN_INTERVAL_MS);
      timerRef.current = setTimeout(tick, delay);
    };
    const initial = MIN_INTERVAL_MS + Math.random() * (MAX_INTERVAL_MS - MIN_INTERVAL_MS);
    timerRef.current = setTimeout(tick, initial);
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  return count;
}
